import $ from 'jquery';

const stores = () => {
  const citySearchDropdown = () =>{
    const opener = $('.city-search');
    const header = $('.header');

    opener.on('click', e =>{
      const {target} = e;
      const current = opener.find('.current span');

      if($(target).closest('.city-search__current').length){
        opener.toggleClass('active');
        header.toggleClass('mobile-bg');
      }

      if($(target).is('li') && !$(target).hasClass('active')){
        const text = $(target).text();
        opener.find('li').not(target).removeClass('active');
        $(target).addClass('active')
        current.text(text);
        opener.removeClass('active');

        $('.header').removeClass('mobile-bg');
      }
    });

    $(document).mouseup(e => {
      if (!opener.is(e.target) && opener.has(e.target).length === 0) {
        opener.removeClass("active");
        header.removeClass('mobile-bg');

        // Erase input
        setTimeout(() => {
          const searchInput = document.querySelector(".js-search-stores");
          if (!searchInput) return;
          searchInput.value = "";
          searchInput.removeAttribute("value");
          searchInput.dispatchEvent(new Event("keyup"));
        }, 300);
      }
    });
  }

  citySearchDropdown();
}

export default stores;